import { List, Record } from 'immutable';
import { Adjustment } from '../../event/models/adjustment';
import { Payment } from '../../event/models/payment';

const PaymentEquationRecord = Record({
  roomCommissions: null,
  adjustments: null,
  prepayment: null,
  totalPaymentRequested: null,
});

export class PaymentEquation extends PaymentEquationRecord {
  roomCommissions: number;
  adjustments: List<Adjustment>;
  prepayment: Payment;
  totalPaymentRequested: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/model/payment-equation.ts